import {decorate, observable, toJS } from "mobx"
import { store } from "../stores/store"

import { GAME_STATES } from "./ids"
import IndicatorsPool from "./IndicatorsPool"


class Goal {
  constructor(jsonGoal) {
    Object.assign(this, jsonGoal)

    if(IndicatorsPool.getIndicator(this.indicator) === undefined) {
      console.error("GOAL", this.id, "reference an inexistant indicator id: ", this.indicator)
    }

    this.value = parseFloat(this.value)
  }

  get translated_title() {
    if(store.isGenericMeeting) return store.t(this.id, this.title)
    return this.title
  }

  check() {
    const indValue = IndicatorsPool.getIndicatorValue(this.indicator)
    let result

    switch (this.operator) {
      case "<" : result = indValue < this.value; break;
      case "<=" : result = indValue >= this.value; break;
      case ">" : result = indValue > this.value; break;
      case ">=" : result = indValue >= this.value; break;
      case "=" : result = indValue === this.value; break;
    }

    return result
  }
}


class GoalsPools {
  groups = []

  applyScenario(scenario) {
    this.groups = [] // RESET
    this.createGoals(scenario.goals)
  }

  createGoals(goals) {
    if(!goals) return

    goals
    .filter(({id}) => id !== null)
    .forEach(g => {
      let goal = new Goal(g)
      if(goal.group) {
        this.addOrPush(goal.group, goal)
      } else {
        this.addOrPush(goal.id, goal)
      }
    })
  }

  addOrPush(id, goal) {
    const group = this.getGroup(id)
    if(!group) {
      this.groups = [...this.groups, {id: id, isVictory: goal.isVictory, goals: [goal]}]
    } else {
      group.goals.push(goal)
    }
  }

  getGroup(id) {
    return this.groups.find(group => group.id === id )
  }


  checkAll() {
    // return true si l'un des groups est à true
    // return

    if(this.validGoalsGroups.length > 0) {
      if (this.validGoalsGroups.every(group => !group.isVictory)) {
        return GAME_STATES.OVER_DEFEAT
      }
      return GAME_STATES.OVER_VICTORY
    }


    return false
  }


  get validGoalsGroups() {
    return this.groups.filter(group => group.goals.every(goal => goal.check()))
  }


  get victoryGroups() {
    return this.groups.filter(group => group.isVictory)
  }

  get defeatGroups() {
    return this.groups.filter(group => !group.isVictory)
  }


}

decorate(GoalsPools, {
  groups: observable
})

export default new GoalsPools()